import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { LoginPageStyles } from './LoginPage.styles';
import { AuthWaves, UserIcon } from './AuthParts';
import { FormGroup, Label } from '../common/formInputsV2/styles/common';
import { PrimaryButton } from '../common/formInputsV2/Button.styles';

import GreeniaLogo from '../assets/images/greenia-logo.svg';
import { requestForgotPassword, resetForgotPassword } from '../features/auth/authActions';

const schema = yup.object({
  email: yup
    .string()
    .required('Il campo è obbligatorio'),
});

export function ForgotPassword() {
  const navigate = useNavigate();
  const userState = useSelector((store) => store.user);
  const forgotPasswordState = useSelector((store) => store.auth.forgotPassword);

  useEffect(() => {
    if (userState.token) {
      navigate('/');
    }
  }, [userState.token]);

  useEffect(() => () => {
    resetForgotPassword();
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: yupResolver(schema),
    shouldFocusError: true,
  });

  const submitData = (data) => {
    requestForgotPassword(data, () => {
      reset();
    });
  };

  return (
    <LoginPageStyles>
      <AuthWaves />

      <form onSubmit={handleSubmit(submitData)} className="login-card" noValidate>
        <div className="login-logo">
          <img src={GreeniaLogo} width={170} alt="Greenia Logo" />
        </div>
        <h1 className="login-title">Hai dimenticato la password?</h1>
        <p className="login-subtitle">
          Inserisci la tua email e ti invieremo il collegamento per reimpostarla
        </p>

        {forgotPasswordState.error !== null && (
          <div className="login-error" role="alert">{forgotPasswordState.error}</div>
        )}
        {forgotPasswordState.success === true && (
          <div className="login-success" role="status">
            Ti abbiamo inviato un'e-mail con il collegamento per il ripristino
          </div>
        )}

        <FormGroup className="login-group">
          <Label htmlFor="email">Email</Label>
          <div className="login-field">
            <UserIcon />
            <input
              {...register('email')}
              id="email"
              autoComplete="username"
              className={`form-control ${errors.email ? 'is-invalid' : ''}`}
              aria-invalid={errors.email ? 'true' : undefined}
              aria-describedby={errors.email ? 'email-error' : undefined}
            />
            <div className="invalid-feedback" id="email-error">{errors.email?.message}</div>
          </div>
        </FormGroup>

        <div className="login-submit">
          <PrimaryButton type="submit" disabled={forgotPasswordState.loading}>
            {forgotPasswordState.loading ? 'Attendere prego...' : 'Richiedi reimpostazione'}
          </PrimaryButton>
        </div>
        <p className="login-forgot">
          <Link to="/login">Torna all'accesso</Link>
        </p>
      </form>
    </LoginPageStyles>
  );
}
